import _ from 'lodash';

export default function IdTypeInPersonVoting({ stateInfos }) {
  const governmentPhotoId = [];
  const photoId = [];
  const id = [];
  const havaOnly = [];

  stateInfos.forEach((state) => {
    const stateData = _.keyBy(state.nodes, 'field_type');

    const stateValue = stateData.id_type_in_person_voting.text;

    if (stateValue === 'government_photo_id') {
      governmentPhotoId.push(state);
    } else if (stateValue === 'photo_id') {
      photoId.push(state);
    } else if (stateValue === 'id') {
      id.push(state);
    } else if (stateValue === 'hava_only') {
      havaOnly.push(state);
    }
  });

  return [
    {
      title: 'Voters must show government photo ID',
      states: governmentPhotoId,
    },
    {
      title: 'Voters must show photo ID',
      states: photoId,
    },
    {
      title: 'Voters must show ID',
      states: id,
    },
    {
      title: 'Only first-time voters show ID',
      states: havaOnly,
    },
  ];
}
